import React, { useEffect, useState } from 'react';
import * as S from '../styles';

export default function CenteredMetric({ dataWithArc, centerX, centerY }) {
    const [total, setTotal] = useState(0);

    useEffect(() => {
        let newTotal = 0;

        dataWithArc.forEach((data) => {
            newTotal += data.value;
        });

        setTotal(newTotal);
    }, [dataWithArc]);

    return (
        <>
            <S.TextCenteredMetric
                x={centerX}
                y={centerY - 10}
                textAnchor="middle"
                dominantBaseline="central"
                className="quantity"
            >
                {total}
            </S.TextCenteredMetric>

            <S.TextCenteredMetric
                x={centerX}
                y={centerY + 20}
                textAnchor="middle"
                dominantBaseline="central"
                className="label"
            >
                Total
            </S.TextCenteredMetric>
        </>
    );
}
